import { Tabs } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const STabs = styled(Tabs)``;

export const STabBodyWrapper = styled.div<{ minHeight?: string }>`
  min-height: ${props => (props.minHeight ? `${props.minHeight}` : '30px')};
`;
